module.exports = __webpack_public_path__ + "img/icon-account.0e1d19ec.svg";